// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vTkI862uhGB_CucXnCMU {
  background-color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/cookie-modal/index.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;AACF","sourcesContent":[".tab_pane {\n  background-color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab_pane": `vTkI862uhGB_CucXnCMU`
};
export default ___CSS_LOADER_EXPORT___;
